<template>
  <pro-layout
    :menus="menus"
    :collapsed="collapsed"
    :mediaQuery="query"
    :isMobile="isMobile"
    :handleMediaQuery="handleMediaQuery"
    :handleCollapse="handleCollapse"
    :i18nRender="i18nRender"
    v-bind="settings"
    style="display: flex;"
  >
    <!-- Ads begin
      广告代码 真实项目中请移除
      production remove this Ads
    -->
    <!-- <ads v-if="isProPreviewSite && !collapsed"/> -->
    <!-- Ads end -->

    <!-- layout content -->
    <!-- 2021.01.15 默认固定页头，去掉样式paddingTop: fixedHeader ? '64' : '0'  -->

    <!-- 1.0.0+ 版本 pro-layout 提供 API，
          我们推荐使用这种方式进行 LOGO 和 title 自定义
    -->
    <template v-slot:menuHeaderRender>
      <div style="display: flex;">
        <!-- v-if="settings.theme=='light'" -->
        <img
          src="~@/assets/logo1.png"
          class="logo"
          style="width: auto;"
          alt="logo"
        >
        <!-- <img src="~@/assets/login_font.png" class="logo" style="width: auto;" alt="logo"> -->
        <!-- <img v-else src="~@/assets/logo2.png" class="logo" style="width: auto;" alt="logo"> -->
        <!-- <span>{{ settings.theme }}</span> -->
        <!-- <h1>{{ title }}</h1> -->
      </div>
    </template>

    <!-- <setting-drawer v-if="isProPreviewSite" :settings="settings" @change="handleSettingChange" /> -->
    <template v-slot:rightContentRender>
      <a-layout-content
        class="topBtn-hidden"
        :style="{ height: '100%', margin: '0 0 0 210px'}"
        style="flex: 1;overflow-x: auto;"
      >
        <!-- <div style="display: flex;position: fixed;top:0;left: 0;height:40px;background:#fff;" >
          <img src="~@/assets/logo.png" class="logo" style="width: 20px;height:20px;margin-right:10px;" alt="logo">
          <img src="~@/assets/login_font.png" class="logo" style="height:20px;" alt="logo">
        </div> -->
        <multi-tab v-if="defaultSettings.isShowMultiTab"></multi-tab>
        <top-btn v-else></top-btn>

        <transition name="page-transition">
        </transition>
        <!-- <div style="line-height: 20px;">
          <a-breadcrumb v-if="activePageInfo">
            <a-breadcrumb-item><router-link to="/">首页</router-link></a-breadcrumb-item>
            <a-breadcrumb-item>{{ activePageInfo.title }}</a-breadcrumb-item>
          </a-breadcrumb>
        </div> -->
      </a-layout-content>

      <right-content
        :top-menu="settings.layout === 'topmenu'"
        :is-mobile="isMobile"
        :theme="settings.theme"
      />
    </template>
    <!-- <template v-slot:footerRender v-if="!hideFooter">
      <global-footer />
    </template> -->
    <keep-alive v-if="isKeep">
      <router-view :key="key" />
    </keep-alive>
    <router-view
      v-else
      :key="key"
    />
  </pro-layout>
</template>

<script>
import MultiTab from '@/components/MultiTab'
import TopBtn from '@/components/TopBtn'
// import { updateTheme } from '@/components/ProLayout'
import SettingDrawer from '@/components/SettingDrawer'
import { i18nRender } from '@/locales'
import { mapState } from 'vuex'
import {
  CONTENT_WIDTH_TYPE,
  SIDE_COLLAPSED,
  TOGGLE_MOBILE_TYPE,
  TOGGLE_CONTENT_WIDTH,
  TOGGLE_FIXED_HEADER,
  TOGGLE_FIXED_SIDEBAR,
  TOGGLE_LAYOUT,
  TOGGLE_NAV_THEME,
  TOGGLE_WEAK,
  TOGGLE_COLOR,
  TOGGLE_MULTI_TAB,
  TABLE_SIZE,
  TABLE_BORDERED,
  HIDE_FOOTER
} from '@/store/mutation-types'

import defaultSettings from '@/config/defaultSettings'
import RightContent from '@/components/GlobalHeader/RightContent'
import GlobalFooter from '@/components/GlobalFooter'
import Ads from '@/components/Other/CarbonAds'
import { baseMixin } from '@/store/app-mixin'

export default {
  name: 'BasicLayout',
  components: {
    SettingDrawer,
    RightContent,
    GlobalFooter,
    Ads,
    MultiTab,
    TopBtn
  },
  mixins: [baseMixin],
  data () {
    return {
      // preview.pro.antdv.com only use.是否展示设置页面样式按钮；先写死 true;后续可根据 process.env.VUE_APP_PREVIEW === 'true', 进行控制
      isProPreviewSite: true, // process.env.VUE_APP_PREVIEW === 'true',
      // end
      // base
      menus: [],
      // 侧栏展开状态
      collapsed: false,
      title: defaultSettings.title,
      settings: {
        // 布局类型
        layout: defaultSettings.layout, // 'sidemenu', 'topmenu'
        // CONTENT_WIDTH_TYPE
        contentWidth: defaultSettings.layout === 'sidemenu' ? CONTENT_WIDTH_TYPE.Fluid : defaultSettings.contentWidth,
        // 主题 'dark' | 'light'
        theme: defaultSettings.navTheme,
        // 主色调
        primaryColor: defaultSettings.primaryColor,
        fixedHeader: defaultSettings.fixedHeader,
        fixSiderbar: defaultSettings.fixSiderbar,
        multiTab: defaultSettings.multiTab,
        colorWeak: defaultSettings.colorWeak,

        hideHintAlert: true,
        hideCopyButton: false,
        tableSize: defaultSettings.tableSize,
        tableBordered: defaultSettings.tableBordered,
        hideFooter: defaultSettings.hideFooter
      },
      defaultSettings,
      // 媒体查询
      query: {},
      routeList: {} // 路由列表
    }
  },
  watch: {
    // 监听路由，记录已经打开的路由信息及当前打开路由时的路由key
    $route (path) {
      let fullPath = path.fullPath.split('#')[0]
      if (this.routeList[fullPath]) {
        this.routeList[fullPath] = this.routerKey
      }
    }
  },
  computed: {
    ...mapState({
      // 动态主路由
      mainMenu: state => state.permission.menus,
      excludePage: state => state.app.excludePage, // 点击刷新页面时的路由
      pageHide: state => state.app.pageHide,
      routerKey: state => state.app.routerKey // 刷新页面时的路由key
    }),
    cachedViews () {
      return this.$store.state.tagsView.cachedViews
    },
    activePageInfo () {
      return this.$store.state.app.activePageInfo
    },
    // key () {
    //   console.log('$route>>>>>>>>>>>>>>>>', this.$route)

    //   const t = this.routeList[this.$route.fullPath] // 获取当前页面路由对应的key
    //   // 如果当前路由页面点击了刷新页面
    //   if (this.excludePage[0] === this.$route.fullPath) {
    //     // eslint-disable-next-line vue/no-side-effects-in-computed-properties
    //     this.routeList[this.$route.fullPath] = this.routerKey // 重新记录当前页面对应的路由key
    //     console.log('key>>>>>>', this.$route.fullPath + '?t=' + this.routerKey)

    //     return this.$route.fullPath + '?t=' + this.routerKey // 更新路由key
    //   } else {
    //     console.log('key>>>>>>', this.$route.fullPath + '?t=' + t)

    //     return this.$route.fullPath + '?t=' + t // 使用之前记录中的路由key
    //   }
    //   // return this.$route.fullPath
    // },
    key () {
      console.log('$route>>>>>>>>>>>>>>>>', this.$route)
      let fullPath = this.$route.fullPath.split('#')[0]

      const t = this.routeList[fullPath] // 获取当前页面路由对应的key
      // 如果当前路由页面点击了刷新页面
      if (this.excludePage[0] === fullPath) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.routeList[fullPath] = this.routerKey // 重新记录当前页面对应的路由key
        console.log('key>>>>>>', fullPath + '?t=' + this.routerKey)

        return fullPath + '?t=' + this.routerKey // 更新路由key
      } else {
        console.log('key>>>>>>', fullPath + '?t=' + t)

        return fullPath + '?t=' + t // 使用之前记录中的路由key
      }
      // return this.$route.fullPath
    },
    isKeep () {
      const keyList = this.key.split('/') || []
      if (keyList.length > 3) {
        return true
      } else {
        return true
      }
    }
  },
  created () {
    const routes = this.mainMenu.find(item => item.path === '/')

    this.menus = (routes && routes.children) || []

    console.log('routes>>>>>>', routes)
    console.log('menus>>>>>>', this.menus)

    // 处理侧栏展开状态
    this.$watch('collapsed', () => {
      this.$store.commit(SIDE_COLLAPSED, this.collapsed)
    })
  },
  mounted () {
    if (this.isProPreviewSite) {
      this.settings.layout = this.layout
      this.settings.contentWidth = this.contentWidth
      this.settings.theme = this.navTheme
      this.settings.primaryColor = this.primaryColor
      this.settings.fixedHeader = this.fixedHeader
      this.settings.fixSiderbar = this.fixedSidebar
      this.settings.multiTab = this.multiTab
      this.settings.colorWeak = this.colorWeak
      this.settings.tableSize = this.tableSize
      this.settings.tableBordered = this.tableBordered
      this.settings.hideFooter = this.hideFooter
    }
    this.collapsed = this.sideCollapsed
    const userAgent = navigator.userAgent
    if (userAgent.indexOf('Edge') > -1) {
      this.$nextTick(() => {
        this.collapsed = !this.collapsed
        setTimeout(() => {
          this.collapsed = !this.collapsed
        }, 16)
      })
    }

    // first update color
    // TIPS: THEME COLOR HANDLER!! PLEASE CHECK THAT!!
    // if (process.env.NODE_ENV !== 'production' || process.env.VUE_APP_PREVIEW === 'true') {
    //   updateTheme(this.settings.primaryColor)
    // }
  },
  methods: {
    i18nRender,
    handleMediaQuery (val) {
      this.query = val
      if (this.isMobile && !val['screen-xs']) {
        this.$store.commit(TOGGLE_MOBILE_TYPE, false)
        return
      }
      if (!this.isMobile && val['screen-xs']) {
        this.$store.commit(TOGGLE_MOBILE_TYPE, true)
        this.collapsed = true
        this.settings.contentWidth = CONTENT_WIDTH_TYPE.Fluid
        // this.settings.fixSiderbar = false
      }
    },
    handleCollapse (val) {
      this.collapsed = val
    },
    handleSettingChange ({ type, value }) {
      type && (this.settings[type] = value)
      switch (type) {
        case 'theme':
          this.$store.commit(TOGGLE_NAV_THEME, value)
          break
        case 'primaryColor':
          this.$store.commit(TOGGLE_COLOR, value)
          break
        case 'contentWidth':
          this.settings[type] = value
          this.$store.commit(TOGGLE_CONTENT_WIDTH, value)
          break
        case 'layout':
          this.$store.commit(TOGGLE_LAYOUT, value)
          if (value === 'sidemenu') {
            this.settings.contentWidth = CONTENT_WIDTH_TYPE.Fluid
            this.$store.commit(TOGGLE_CONTENT_WIDTH, CONTENT_WIDTH_TYPE.Fluid)
          } else {
            this.settings.fixSiderbar = false
            this.$store.commit(TOGGLE_FIXED_SIDEBAR, false)
            this.settings.contentWidth = CONTENT_WIDTH_TYPE.Fixed
            this.$store.commit(TOGGLE_CONTENT_WIDTH, CONTENT_WIDTH_TYPE.Fixed)
          }
          break
        case 'fixSiderbar':
          this.$store.commit(TOGGLE_FIXED_SIDEBAR, value)
          break
        case 'fixedHeader':
          this.$store.commit(TOGGLE_FIXED_HEADER, value)
          break
        case 'multiTab':
          this.$store.commit(TOGGLE_MULTI_TAB, value)
          break
        case 'colorWeak':
          this.$store.commit(TOGGLE_WEAK, value)
          break
        case 'tableSize':
          this.$store.commit(TABLE_SIZE, value)
          break
        case 'tableBordered':
          this.$store.commit(TABLE_BORDERED, value)
          break
        case 'hideFooter':
          this.$store.commit(HIDE_FOOTER, value)
          break
      }
    }
  }
}
</script>

<style lang="less">
@import './BasicLayout.less';
</style>
